import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import type { ColumnDef } from "@tanstack/react-table";
import { listMyRealms } from "../lib/api";
import type { Realm } from "../lib/types";
import DataTable from "../components/DataTable";
import WriteOpsHint from "../components/WriteOpsHint";
import { REALMS_WRITE_OPS } from "../writeops/realms";

const COLS: ColumnDef<Realm, any>[] = [
  { header: "ID", accessorKey: "id" },
  { header: "Kind", accessorKey: "kind" },
  { header: "Display", accessorKey: "display_name" },
  { header: "Visibility", accessorKey: "visibility" },
  {
    header: "Packs",
    accessorKey: "pack_bindings",
    cell: (c) => (
      <span className="text-xs font-mono text-kw-text-muted">
        {((c.getValue() as string[]) ?? []).join(", ") || "—"}
      </span>
    ),
  },
];

export default function RealmsRoute() {
  const [realms, setRealms] = useState<Realm[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        setRealms(await listMyRealms());
      } catch (e: any) {
        setError(e.message ?? String(e));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="px-8 py-6 space-y-6">
      <h2 className="text-lg font-medium">Realms</h2>
      {loading && <div className="text-kw-text-muted text-sm">Lade...</div>}
      {error && <div className="text-red-400 text-sm">{error}</div>}
      {!loading && !error && (
        <DataTable
          columns={COLS}
          data={realms}
          emptyHint="No realms visible to you — you are neither an owner nor a member of one."
          onRowClick={(r) => nav(`/realms/${encodeURIComponent(r.id)}`)}
        />
      )}
      <WriteOpsHint title="Realm-Write-Ops" ops={REALMS_WRITE_OPS} />
    </div>
  );
}
